type HttpError = {
  status: number;
};
export function parseHttpError(err: unknown): HttpError {
  const status = err instanceof Error
    && typeof err.cause === 'object'
    && err.cause
    && 'status' in err.cause
    && typeof err.cause.status === 'number'
    ? err.cause.status
    : -1;

  return { status };
}
